import {api} from "@/api/api";
import {Balance, BalanceDTO} from "@/common/types/api/solana.types.api";

export const solana = api.injectEndpoints({
  endpoints: (build) => ({
    Balance: build.query<Balance, {address: string} & { token?: string }>({
      query: ({address, token}) => ({
        url: `/v4/solana/balance?address=${encodeURIComponent(address)}`,
        method: "GET",
        arg:{token},
        transformResponse: (response: BalanceDTO): Balance => ({
          ...response,
          znx: BigInt(response.znx),
          sol: BigInt(response.sol),
          usdc: BigInt(response.usdc),
          token: response.token.map((t) => ({
            ...t,
            amount: BigInt(t.amount)
          }))
        }),
      }),
    }),
  }),
  overrideExisting: true,
});

export const { useLazyBalanceQuery
} = solana;
